import SidebarContent from "./SidebarContent";
import { useSidebar } from "../../context/SidebarContext";

const Sidebar = () => {
	// Horizontal collapse → icon-only rail. State is shared via SidebarContext
	// so the header hamburger (outside the drawer) can toggle it.
	const { collapsed } = useSidebar();

	return (
		<aside
			className={`z-30 flex-shrink-0 hidden overflow-y-auto bg-white shadow-lg lg:block transition-all duration-300 ${
				collapsed ? "w-20" : "w-64"
			}`}
		>
			<SidebarContent />
		</aside>
	);
};

export default Sidebar;
